import { typographyRecipe as e, typeFacePrimitives as s } from "@huspy/briks-core";
import { defineRecipe as a } from "@pandacss/dev";
const { "sans-serif": r } = e.size;
function n(f) {
  return Object.keys(r).filter((t) => f === "text" ? !t.includes("h") : t.includes("h")).reduce(
    (t, i) => (t[i] = r[i], t),
    {}
  );
}
const l = a({
  className: "text",
  base: {
    fontFamily: s["sans-serif"]
  },
  variants: {
    size: n("text"),
    weight: e.weight,
    variant: e.variant
  }
}), p = a({
  className: "title",
  base: {
    fontFamily: s["sans-serif"]
  },
  variants: {
    size: n("title"),
    weight: e.weight,
    variant: e.variant
  }
});
export {
  l as text,
  p as title
};
